export function ImportantCtaBoxDescription({ children }: { children: React.ReactNode }) {
    return (
        <div data-id="important-cta-box-description" className="mb-5">
            {children}
        </div>
    );
}
